import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import { IS_SPINNER_ACTIVE } from '../../../util/interceptors';
import { UrlService } from '../../../../environments/urlService';
import { ProfileDTO, UserUpdateDTO } from '../../user/profile/dto/ProfileDTO';


@Injectable({
  providedIn: 'root',
})
export class CabinetService {
  private httpClient = inject(HttpClient);
  private urlService = inject(UrlService);
  private url: string;
  private _profile = new BehaviorSubject<ProfileDTO>(null);

  constructor() {
    this.url = this.urlService.getModelsUrl() + 'user/';
  }

  public updateUserProfile(dto: UserUpdateDTO): Observable<void> {
   return this.httpClient.put<void>(this.url, dto, {
      withCredentials: true,
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      responseType: 'json',
    });
  }

  setProfile(profile: ProfileDTO): void {
    this._profile.next(profile);
  }

  get profile(): BehaviorSubject<ProfileDTO | null> {
    return this._profile;
  }
}
